import AccountActionsService from '../Service/account-actions-service';
import { useContext, useMemo } from 'react';
import { AppContext } from './AppContext';

export const useAccountService = () => {
  const { userInfo, portals, accountOptions } = useContext(AppContext);

  const accountActionsService = useMemo(
    () =>
      new AccountActionsService(
        userInfo,
        portals.currentPortalId,
        portals.portals,
      ),
    [portals.currentPortalId, portals.portals, userInfo],
  );

  return {
    accountOptions,
    accountActionsService,
  };
};
